import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { NewsletterSignup } from '../../banners/NewsletterSignup/NewsletterSignup'
import { ThemeMargins } from '../../__styling/settings/metrics'

export type NewsletterVariants =
    | 'default'
    | 'journo-profile'
    | 'sidebar-article'
    | 'inline-article'
export interface NewsletterSignupRouteProps {
    text: string
    buttonLabel: string
    verticalSpacing?: keyof ThemeMargins
    subText?: string
    mode: NewsletterVariants
}

export const NewsletterSignupRegistration = createRegisterableComponent(
    'newsletter-signup',
    (props: NewsletterSignupRouteProps, services) => (
        <NewsletterSignup
            {...props}
            api={services.config.contentApi}
            onEvent={services.onEvent}
        />
    ),
)
